import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl, EmailValidator } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { DatePipe } from '@angular/common'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { PersonCountService } from 'src/app/Services/PersonCount/person-count.service';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-people-counter-report',
  templateUrl: './people-counter-report.component.html',
  styleUrls: ['./people-counter-report.component.css']
})
export class PeopleCounterReportComponent implements OnInit {

  @ViewChild('canvas') canvas: ElementRef;

  chart: any;

  
  queryForm:FormGroup;

  branch;
  branchfromlogin;
  error:any = '';
success = '';
branchs;
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;
currentUser:User;
role;
username;
salesRepID;

dailycount;
  currentmonthcount;
  currentweekcount
  annualcount;
  monthlyCountDiff;
  dailyCountDiff;
  weekCountDiff;
  annualCountDiff;

  dailyGraphData;
  weeklyGraphData;
  monthlyGraphData;
  annualGraphData;

  @Input() graphData: any;
  currentChartType: string = 'year';  // Default to Year

  constructor(private fb: FormBuilder,
    private router: Router,
    private _location: Location,
    private _http: HttpClient,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private _appointment: AppointmentService,
    private _personcount: PersonCountService,
    public datepipe: DatePipe) {

      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.branchfromlogin=this.currentUser.branch
        this.role=this.currentUser.role;


  
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
     }




  ngOnInit(): void {

this.getPersonCountStats();
this.getGraphData();

    this.queryForm= this.fb.group({
    pid: new FormControl(''),
     branch: new FormControl('',[Validators.required]),
     requestType: new FormControl(''),
     status: new FormControl(''),
     startTime: new FormControl(''),
     endTime: new FormControl(''),
     duration: new FormControl(''),
    personCount: new FormControl('Unknown'),     
   });





  }//End of ngOnInit
 


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.annualGraphData && !changes.annualGraphData.firstChange) {
      this.drawChart();
    }
  }

  toggleChart(chartType: string): void {
    this.currentChartType = chartType;
    this.updateChart();
  }

  getPersonCountStats() {
    var year= new Date().getFullYear();
    this._personcount.getAllPersonCountStats(this.branch,year).subscribe(
    (res) => {
     this.dailycount=res[0]['dailycount'];
     this.currentweekcount= res[0]['currentweekcount'];
     this.currentmonthcount= res[0]['currentmonthcount'];
     this.annualcount = res[0]['annualcount'];

     this.dailyCountDiff = res[0]['dailyCountDiff'];
     this.weekCountDiff = res[0]['weekCountDiff'];
     this.monthlyCountDiff = res[0]['monthCountDiff'];
     this.annualCountDiff = res[0]['annualCountDiff'];
       console.log(res[0]['annualcount']);
    }
    ,
    (err) => {
      this.error = err;
    }
  );
  }

  getGraphData() {
    var year= new Date().getFullYear();
    this._personcount.getGraphData(this.branch,year).subscribe(
    (res) => {
      this.dailyGraphData =res[0]['dailyGraphData'];
     this.weeklyGraphData= res[0]['weeklyGraphData'];
     this.monthlyGraphData= res[0]['monthlyGraphData'];
     this.annualGraphData = res[0]['annualGraphData'];

   this.graphData=this.dailyGraphData;
   this.drawChart();
     /**this.createDailyChart();
     this.createWeeklyChart();
     this.createMonthlyChart();
     this.createAnnualChart();
**/
       console.log(res[0]['res']);
    }
    ,
    (err) => {
      this.error = err;
    }
  );
  }



 /******************************************************************************** */

  drawChart(): void {
    if (this.graphData) {
      const labels = Object.keys(this.graphData);
      const data = Object.values(this.graphData);
      var fillColor = 'rgba(' + Math.floor(Math.random() * 100) + ',' + Math.floor(Math.random() * 100) + ',' + Math.floor(Math.random() * 100) + ', 0.6)';
      this.chart = new Chart(this.canvas.nativeElement, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [{
            label: 'Person Count',
            data: data,
            backgroundColor: fillColor,
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1
          }]
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      });
    }
  }
 /******************************************************************************** */
  /**createDailyChart(){

    const labels = Object.keys(this.dailyGraphData);
    const data = Object.values(this.dailyGraphData);
    this.chart = new Chart(this.canvas.nativeElement, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Person Count',
          data: data,  // Replace with the actual values you received
          backgroundColor: [
            'rgba(75, 192, 192, 0.2)',
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(54, 162, 235, 0.2)'
          ],
          borderColor: [
            'rgba(75, 192, 192, 1)',
            'rgba(255, 99, 132, 1)',
            'rgba(255, 205, 86, 1)',
            'rgba(54, 162, 235, 1)'
          ],
          borderWidth: 1
        }]
      },
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
  }**/


 /******************************************************************************** */
 /**createWeeklyChart(){

  const labels = Object.keys(this.weeklyGraphData);
  const data = Object.values(this.weeklyGraphData);
  this.chart = new Chart(this.canvas.nativeElement, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        label: 'Person Count',
        data: data,  // Replace with the actual values you received
        backgroundColor: [
          'rgba(75, 192, 192, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(54, 162, 235, 0.2)'
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
          'rgba(255, 205, 86, 1)',
          'rgba(54, 162, 235, 1)'
        ],
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    }
  });
}
**/

 /******************************************************************************** */
 /**createMonthlyChart(){

  const labels = Object.keys(this.monthlyGraphData);
  const data = Object.values(this.monthlyGraphData);
  this.chart = new Chart(this.canvas.nativeElement, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        label: 'Person Count',
        data: data,  // Replace with the actual values you received
        backgroundColor: [
          'rgba(75, 192, 192, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(54, 162, 235, 0.2)'
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
          'rgba(255, 205, 86, 1)',
          'rgba(54, 162, 235, 1)'
        ],
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    }
  });
}**/

  /******************************************************************************** */
/**

createAnnualChart(){

  const labels = Object.keys(this.annualGraphData);
  const data = Object.values(this.annualGraphData);
  this.chart = new Chart(this.canvas.nativeElement, {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        label: 'Person Count',
        data: data,  // Replace with the actual values you received
        backgroundColor: [
          'rgba(75, 192, 192, 0.2)',
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(54, 162, 235, 0.2)'
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
          'rgba(255, 205, 86, 1)',
          'rgba(54, 162, 235, 1)'
        ],
        borderWidth: 1
      }]
    },
    options: {
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          }
        }]
      }
    }
  });
}**/


updateChart(): void {
  if (this.currentChartType === 'day') {
    // Update the chart with daily data
   this.graphData = this.dailyGraphData;
    this.drawChart();
  } else if (this.currentChartType === 'week') {
    // Update the chart with weekly data
    this.graphData = this.weeklyGraphData;
    this.drawChart();
  } else if (this.currentChartType === 'month') {
    // Update the chart with monthly data
    this.graphData = this.monthlyGraphData;
    this.drawChart();
  } else if (this.currentChartType === 'year') {
    // Update the chart with yearly data
    this.graphData = this.annualGraphData;
    this.drawChart();
  }
}
}
